import styled from 'styled-components';

export const StyledBroadsiderInfo = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "BebasNeue";
  font-size: 1.25em;
  color: white;
  line-height: 0.75;
  text-transform: uppercase;
  text-align: end;
  gap: 8px;

  .info-field {
    opacity: 0.4;
  }
`;
